// extracted by mini-css-extract-plugin
export default {"ourStoryContainer":"OurStory_ourStoryContainer__U+Qgi","ourStoryText":"OurStory_ourStoryText__IU6vF"};